import React from "react";

function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer-section" id="contact">
      <div className="footer-inner">

        <div className="footer-badge">
          <span className="badge-dot" />
          <span>Available for new projects</span>
        </div>

        <h2 className="footer-heading">
          Let's Build<br />
          <span className="heading-accent">Something Extraordinary</span>
        </h2>

        <p className="footer-sub">
          Always open to new projects, creative ideas, or opportunities to be part of your vision.
        </p>

        <a href="mailto:shahid.example@email.com" className="footer-cta">
          <span>Get In Touch</span>
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M5 12h14M12 5l7 7-7 7" />
          </svg>
        </a>

        <div className="footer-divider" />

        <div className="social-row">
          <span className="social-label">Follow me on</span>
          <div className="social-links">
            {[
              {
                href: "https://github.com/Shahid-Sheimi",
                label: "GitHub",
                icon: <path d="M12 0C5.37 0 0 5.37 0 12c0 5.31 3.435 9.795 8.205 11.385.6.105.825-.255.825-.57 0-.285-.015-1.23-.015-2.235-3.015.555-3.795-.735-4.035-1.41-.135-.345-.72-1.41-1.23-1.695-.42-.225-1.02-.78-.015-.795.945-.015 1.62.87 1.845 1.23 1.08 1.815 2.805 1.305 3.495.99.105-.78.42-1.305.765-1.605-2.67-.3-5.46-1.335-5.46-5.925 0-1.305.465-2.385 1.23-3.225-.12-.3-.54-1.53.12-3.18 0 0 1.005-.315 3.3 1.23.96-.27 1.98-.405 3-.405s2.04.135 3 .405c2.295-1.56 3.3-1.23 3.3-1.23.66 1.65.24 2.88.12 3.18.765.84 1.23 1.905 1.23 3.225 0 4.605-2.805 5.625-5.475 5.925.435.375.81 1.095.81 2.22 0 1.605-.015 2.895-.015 3.3 0 .315.225.69.825.57A12.02 12.02 0 0024 12c0-6.63-5.37-12-12-12z" />,
              },
              {
                href: "https://www.linkedin.com/in/shahid-ai-python/",
                label: "LinkedIn",
                icon: <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 01-2.063-2.065 2.064 2.064 0 112.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />,
              },
              {
                href: "https://www.instagram.com/shahid.hoossein/",
                label: "Instagram",
                icon: <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z" />,
              },
              {
                href: "https://twitter.com",
                label: "Twitter",
                icon: <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />,
              },
              {
                href: "https://medium.com",
                label: "Medium",
                icon: <path d="M13.54 12a6.8 6.8 0 01-6.77 6.82A6.8 6.8 0 010 12a6.8 6.8 0 016.77-6.82A6.8 6.8 0 0113.54 12zM20.96 12c0 3.54-1.51 6.42-3.38 6.42-1.87 0-3.39-2.88-3.39-6.42s1.52-6.42 3.39-6.42 3.38 2.88 3.38 6.42M24 12c0 3.17-.53 5.75-1.19 5.75-.66 0-1.19-2.58-1.19-5.75s.53-5.75 1.19-5.75C23.47 6.25 24 8.83 24 12z" />,
              },
            ].map(({ href, label, icon }) => (
              <a key={label} href={href} target="_blank" rel="noreferrer noopener" className="social-link" aria-label={label}>
                <svg viewBox="0 0 24 24" fill="currentColor" width="17" height="17">{icon}</svg>
              </a>
            ))}
          </div>
        </div>

        <div className="footer-bottom">
          <p className="footer-copy">
            © {currentYear} <span className="name">Shahid Hussain</span>. All rights reserved.
          </p>
          <p className="footer-tech">
            <span className="tech-tag">React</span> · <span className="tech-tag">FastAPI</span> · <span className="tech-tag">AI</span>
          </p>
        </div>

      </div>

      <style>{`
        .footer-section {
          position: relative;
          padding: 88px 6vw 48px;
          background: #0f172a;
          overflow: hidden;
        }

        .footer-inner {
          max-width: 680px;
          margin: 0 auto;
          text-align: center;
        }

        .footer-badge {
          display: inline-flex;
          align-items: center;
          gap: 8px;
          padding: 8px 18px;
          background: rgba(45, 212, 191, 0.06);
          border: 1px solid rgba(45, 212, 191, 0.22);
          border-radius: 50px;
          font-family: 'SF Mono', 'Fira Code', monospace;
          font-size: 11px;
          color: #2dd4bf;
          letter-spacing: 0.07em;
          margin-bottom: 28px;
        }
        .badge-dot {
          width: 7px; height: 7px;
          background: #2dd4bf;
          border-radius: 50%;
          animation: pulse 2s ease-in-out infinite;
        }
        @keyframes pulse { 0%,100%{opacity:1} 50%{opacity:0.4} }

        .footer-heading {
          font-size: clamp(2.2rem, 5vw, 3.6rem);
          font-weight: 300;
          line-height: 1.1;
          color: #e2e8f0;
          margin: 0 0 18px;
        }
        .heading-accent {
          color: #60a5fa;
          font-weight: 400;
        }

        .footer-sub {
          font-size: 1rem;
          color: #64748b;
          line-height: 1.8;
          max-width: 440px;
          margin: 0 auto 36px;
        }

        .footer-cta {
          display: inline-flex;
          align-items: center;
          gap: 10px;
          padding: 14px 32px;
          background: #3b82f6;
          color: #fff;
          font-size: 0.95rem;
          font-weight: 500;
          text-decoration: none;
          border-radius: 8px;
          transition: background 0.2s, transform 0.2s;
        }
        .footer-cta:hover {
          background: #2563eb;
          transform: translateY(-2px);
          color: #fff;
          text-decoration: none;
        }

        .footer-divider {
          width: 80px;
          height: 1px;
          background: linear-gradient(90deg, transparent, #334155, transparent);
          margin: 48px auto;
        }

        .social-row {
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 20px;
          flex-wrap: wrap;
          margin-bottom: 48px;
        }
        .social-label {
          font-family: 'SF Mono', 'Fira Code', monospace;
          font-size: 10px;
          color: #475569;
          letter-spacing: 0.12em;
          text-transform: uppercase;
          white-space: nowrap;
        }
        .social-links {
          display: flex;
          gap: 10px;
        }
        .social-link {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 40px; height: 40px;
          border-radius: 10px;
          border: 1px solid #1e293b;
          background: #1e293b;
          color: #94a3b8;
          text-decoration: none;
          transition: border-color 0.2s, color 0.2s, transform 0.2s;
        }
        .social-link:hover {
          border-color: #3b82f6;
          color: #60a5fa;
          transform: translateY(-3px);
        }

        .footer-bottom {
          border-top: 1px solid #1e293b;
          padding-top: 28px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          flex-wrap: wrap;
          gap: 10px;
        }
        .footer-copy {
          font-size: 0.82rem;
          color: #475569;
          margin: 0;
        }
        .footer-copy .name {
          color: #94a3b8;
          font-weight: 500;
        }
        .footer-tech {
          font-family: 'SF Mono', 'Fira Code', monospace;
          font-size: 0.72rem;
          color: #334155;
          margin: 0;
        }
        .tech-tag { color: #60a5fa; }

        @media (max-width: 600px) {
          .footer-section { padding: 64px 5vw 40px; }
          .footer-bottom { flex-direction: column; align-items: center; text-align: center; }
        }
      `}</style>
    </footer>
  );
}

export default Footer;